<ion-card class="inv-card">

  <!-- Header: Company / Organiser Name -->
  <div class="inv-card-header">
    <div class="inv-header-icon-box">
      <ion-icon name="business-outline"></ion-icon>
    </div>
    <div class="inv-header-content">
      <ion-text class="inv-kicker">Invitation</ion-text>
      <h3 class="inv-title">{{ i.FName }}</h3>
    </div>
    @if (i.isResponse) {
    <ion-badge class="inv-responded-badge" color="success">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      Responded
    </ion-badge>
    }
  </div>

  <ion-card-content class="inv-body">

    <!-- Date & Time -->
    <div class="inv-meta-row">
      <div class="inv-meta-item">
        <div class="inv-meta-icon-wrap inv-meta-icon-date">
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
        <div>
          <span class="inv-meta-label">Date</span>
          <span class="inv-meta-value">{{ i.InvDate | date:'EEE, d MMM y' }}</span>
        </div>
      </div>

      <div class="inv-meta-item">
        <div class="inv-meta-icon-wrap inv-meta-icon-time">
          <ion-icon name="time-outline"></ion-icon>
        </div>
        <div>
          <span class="inv-meta-label">Time</span>
          <span class="inv-meta-value">{{ i.InvTime }}</span>
        </div>
      </div>
    </div>

    <!-- Venue -->
    <div class="inv-detail-row">
      <div class="inv-detail-icon-wrap inv-detail-icon-venue">
        <ion-icon name="location-outline"></ion-icon>
      </div>
      <div class="inv-detail-text">
        <span class="inv-meta-label">Venue</span>
        <span class="inv-meta-value">{{ i.Place }}</span>
      </div>
    </div>

    <!-- Details / Description -->
    <div class="inv-detail-row">
      <div class="inv-detail-icon-wrap inv-detail-icon-info">
        <ion-icon name="information-circle-outline"></ion-icon>
      </div>
      <div class="inv-detail-text">
        <span class="inv-meta-label">Details</span>
        <span class="inv-meta-value inv-details-text">{{ i.Details }}</span>
      </div>
    </div>

  </ion-card-content>

  <!-- RSVP Action Strip -->
  <div class="inv-rsvp-strip">
    <span class="inv-rsvp-label">
      <ion-icon name="mail-unread-outline"></ion-icon>
      RSVP
    </span>

    <div class="inv-rsvp-actions">

      <button class="inv-rsvp-btn inv-rsvp-accept" (click)="Iamthere(i.Id, i.isResponse)"
        title="I'll be there">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <span>I'm In</span>
      </button>

      <button class="inv-rsvp-btn inv-rsvp-maybe" (click)="Maybe(i.Id, i.isResponse)"
        title="Not sure yet">
        <ion-icon name="help-circle-outline"></ion-icon>
        <span>Maybe</span>
      </button>

      <button class="inv-rsvp-btn inv-rsvp-decline" (click)="Sorry(i.Id, i.isResponse)"
        title="Can't make it">
        <ion-icon name="close-circle-outline"></ion-icon>
        <span>Decline</span>
      </button>

    </div>
  </div>

</ion-card>